import { AuthenticationResult, InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';

import { HttpResource } from '@modules/core/utils/HttpResource';
import { settingsStore } from '@modules/core/store/SettingsStore';
import { msal } from '@config/msalConfig';
import { IS_DEV, msalConfig } from '@config/config';
import { AppInsights } from './AppInsights';

export class HttpClient {
    static TCMS: HttpResource;

    static init() {
        HttpClient.TCMS = new HttpResource(
            msalConfig.REACT_APP_TCMS_API_URL,
            {},
            {
                getToken: IS_DEV ? null : async () => (await HttpClient.acquireTokenSilent())?.accessToken
            }
        );
    }

    private static async acquireTokenSilent() {
        let response: AuthenticationResult;
        const instance: IPublicClientApplication = msal.instance;
        const scopes = msal.scopes;
        try {
            response = await instance.acquireTokenSilent({
                scopes,
                // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/errors.md#block_iframe_reload
                redirectUri: `${window.location.origin}/redirect.html`
            });
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                AppInsights.trackException({ error }, { type: 'AcquireTokenSilent:Interaction' });
                settingsStore.setIsMsalInteractionRequired(true);
            } else {
                AppInsights.trackException(error, { type: 'AcquireTokenSilent:Relogin' });
                settingsStore.setIsReloginRequired(true);
            }
        }
        return response;
    }
}
